import { AlertType } from '@gym-atoms/Alert/Alert';
import TabView, { OnTabChangeEvent } from '@gym-atoms/TabView/TabView';
import AccessCategoryMappingList from '@gym-organisms/AccessCategoryMapping/AccessCategoryMappingList';
import ProgramAccessCategoryMappingList from '@gym-organisms/AccessCategoryMapping/ProgramAccessCategoryMappingList';
import { Card } from 'primereact/card';
import { RefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router';

const getInitialAccessCategoryTab = (tab?: string) => (tab === 'bookings' ? 1 : 0);

const GymAccessCategoryMappingPage = (props: GymAccessCategoryMappingProps) => {
  const { t } = useTranslation();
  const { chainId, gymId } = useParams<{ chainId: string; gymId: string }>();
  const history = useHistory();
  const location = useLocation<{ accessCategoryTab?: string }>();
  const [activeTab, setActiveTab] = useState(
    getInitialAccessCategoryTab(location.state?.accessCategoryTab)
  );

  const tabViewItems = [
    {
      header: t('GYM_CHAIN_ACCESS_CATEGORY_HEADER.MEMBERSHIPS'),
      content: (
        <AccessCategoryMappingList
          gymId={+gymId}
          chainId={+chainId}
          heading={t('ACCESS_CATEGORY.HEADER_TEXT')}
        />
      )
    },
    {
      header: t('GYM_CHAIN_ACCESS_CATEGORY_HEADER.BOOKINGS'),
      content: <ProgramAccessCategoryMappingList gymId={+gymId} chainId={+chainId} />
    }
  ];

  const onTabChangeHandler = (e: OnTabChangeEvent) => {
    setActiveTab(e.index);
    history.push(`/gymChains/${chainId}/gyms/${gymId}/gymAccessCategories`, {
      accessCategoryTab: e.index === 1 ? 'bookings' : 'memberships'
    });
  };

  return (
    <div className="tab-view-align-custom">
      <Card className="mt10">
        <TabView
          headerClassName="dashboard-header-tabs"
          items={tabViewItems}
          activeTab={activeTab}
          onTabChange={onTabChangeHandler}
        />
      </Card>
    </div>
  );
};

export interface GymAccessCategoryMappingProps {
  alertRef: RefObject<AlertType>;
}

export default GymAccessCategoryMappingPage;
